import React, { useCallback, useContext, useEffect, useState } from 'react';
import debounce from 'just-debounce-it';
import { useSearchContainerStationsLazyQuery } from '../graphql/queries/searchContainerStations.generated';
import { ContainerStationReducedFragment } from '../graphql/fragments/containerStationReduced.generated';
import i18n from '@/utils/i18n';
import ContainerStationsList, {
  CONTAINER_STATION_PAGE_SIZE,
} from '../components/ContainerStationList';
import { ViewerContext } from '../providers/ViewerContextProvider';
import { Role } from '../contants';
import { SearchInput } from './SearchInput';

type ContainerStationSearchProps = {
  onClick: (containerStation: ContainerStationReducedFragment) => void;
  showAddButton?: boolean;
};

export function ContainerStationSearch(props: ContainerStationSearchProps) {
  const { onClick, showAddButton } = props;
  const context = useContext(ViewerContext);
  const readOnly = context.role === Role.eventCleaningEmployee;
  const [searchTerm, setSearchTerm] = useState('');
  const [total, setTotal] = useState(0);
  const [searchResults, setSearchResults] = useState<
    ContainerStationReducedFragment[]
  >([]);
  const [query, { loading }] = useSearchContainerStationsLazyQuery();

  const fetchResults = useCallback(
    debounce(async (search: string, skip: number, take: number) => {
      const { data } = await query({
        variables: {
          search_term: search,
          skip: skip,
          take: take,
        },
      });

      if (data == null) {
        return;
      }
      const res = data.searchContainerStationsPaginated;
      setTotal(res.total);
      setSearchResults(res.container_stations);
    }, 250),
    [],
  );

  useEffect(() => {
    fetchResults.cancel();
    fetchResults(searchTerm, 0, CONTAINER_STATION_PAGE_SIZE);
  }, [searchTerm]);

  useEffect(() => {
    fetchResults.cancel();
    fetchResults(searchTerm, 0, CONTAINER_STATION_PAGE_SIZE);
  }, []);

  return (
    <div>
      <div className="mb-3">
        <SearchInput
          paramName="search"
          placeholder={i18n.t('ContainerStation:searchPlaceholder')}
          label={i18n.t('Common:searchTerm')}
          onChange={setSearchTerm}
        />
      </div>
      <h3>{i18n.t('Common:searchResults')}:</h3>
      <ContainerStationsList
        containerStations={searchResults}
        loading={loading}
        allowSelectingStore={!readOnly}
        loadMore={(skip, take) => {
          fetchResults.cancel();
          fetchResults(searchTerm, skip, take);
        }}
        total={total}
        onClick={onClick}
        showAddButton={showAddButton}
      />
    </div>
  );
}
